var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-cache',{ref:"cache",attrs:{"get-data":_vm.getItem,"id":_vm.$route.query.ownerId},scopedSlots:_vm._u([{key:"default",fn:function({data}){return _c('CommonConfig',{attrs:{"order-type-prop":data.orderType,"status-prop":data.status,"owner-type-prop":data.ownerType,"owner-id-prop":data.ownerId}})}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }